export function mapPersonkategori(personkategori: string[], useSpecialCharacters: boolean): string[] {
  const mapping = {
    Anstalld: 'Anställd',
    Minderarig: 'Minderårig',
    Leverantor: 'Leverantör',
  }

  const reverseMapping = Object.fromEntries(
    Object.entries(mapping).map(([key, value]) => [value, key])
  )

  return personkategori.map((item: string) => {
    if (useSpecialCharacters) {
      return mapping[item] || item
    } else {
      return reverseMapping[item] || item
    }
  })
}